<template>
  <div class="companyApplyBox">
    <Form ref="searchForm" :label-width="120" :model="formCustom" inline>
      <Form-item label="企业名称：" prop="companyName">
        <Input v-model="formCustom.companyName" :maxlength="50" clearable placeholder="请输入"
               style="width: 200px"></Input>
      </Form-item>
      <Form-item label="统一社会信用代码：" prop="organizationCode">
        <Input v-model="formCustom.organizationCode" :maxlength="50" clearable placeholder="请输入"
               style="width: 200px"></Input>
      </Form-item>
      <Form-item label="行业类型：" prop="industryType">
        <Select v-model="formCustom.industryType" clearable filterable placeholder="请选择" style="width: 200px">
          <Option v-for="item in industryTypeList" :value="item.itemValue">{{ item.itemText }}</Option>
        </Select>
      </Form-item>
      <Form-item label="法人姓名：" prop="owner">
        <Input v-model="formCustom.owner" :maxlength="50" clearable placeholder="请输入" style="width: 200px"></Input>
      </Form-item>
      <Form-item label="企业注册地：" prop="countyCode">
        <Cascader v-model="formCustom.countyCode" :data="areaData" change-on-select filterable
                  not-found-text='暂无下级数据，请创建'
                  style="width: 200px" @on-change="changeCountyCode"></Cascader>
      </Form-item>
      <Form-item label="企业规模：" prop="companyScale">
        <Select v-model="formCustom.companyScale" clearable filterable placeholder="请选择" style="width: 200px">
          <Option v-for="item in companyScaleList" :value="item.itemValue">{{ item.itemText }}</Option>
        </Select>
      </Form-item>
      <Form-item label="审批状态：" prop="approvalStatus">
        <Select v-model="formCustom.approvalStatus" clearable filterable placeholder="请选择" style="width: 200px">
          <Option value="2">待审批</Option>
          <Option value="3">审批通过</Option>
          <Option value="4">审批拒绝</Option>
        </Select>
      </Form-item>
      <Form-item>
        <Button type="primary" @click="handleSearch">查询</Button>
        <Button class="iviewButton" @click="handleReset('searchForm')">重置</Button>
      </Form-item>
    </Form>
    <div style="margin-bottom: 20px">
      <Button type="primary" @click="addDialogShow(1)">创建企业</Button>
    </div>
    <div>
      <Table :columns="companyApplyColumns" :data="companyApplyTableData" :loading="loading" aria-describedby=""
             aria-hidden="true" border @on-selection-change="selectionChange">
        <template slot="countyName" slot-scope="{ row }">
          <span>{{ row.provinceName + row.cityName + row.countyName }}</span>
        </template>
        <template slot="approvalStatus" slot-scope="{ row }">
          <span>{{
              row.approvalStatus === 2 ? '待审批' : row.approvalStatus === 3 ? '审批通过' : row.approvalStatus === 4 ? '审批拒绝' : '其他'
            }}</span>
        </template>
        <template slot="action" slot-scope="{ row }">
          <Button v-if="row.approvalStatus !== 3" size="small" type="text" @click="editDialogShow(row)">编辑</Button>
        </template>
      </Table>
      <Page ref="pages" :current="page" :total="total" class="page_position" show-elevator show-sizer show-total
            @on-change="setCurrent" @on-page-size-change="setPage"></Page>
    </div>
    <el-dialog :visible.sync="addDialogVisible" title="创建企业" width="730px">
      <company-apply-add @addSuccess="addSuccess"></company-apply-add>
    </el-dialog>
    <el-dialog :visible.sync="editDialogVisible" title="编辑企业" width="730px">
      <company-apply-edit :key="row.companyId" :row="row" @editSuccess="editSuccess"></company-apply-edit>
    </el-dialog>
  </div>
</template>

<script>
import permissionList from '@/libs/handlePermission.ts'
import {allDivisionTree} from '@/api/public'
import {companyScaleList, industryTypeList} from '@/api/authority'
import {companyApplyPage} from '@/api/organization'
import companyApplyAdd from '@/views/organization/companyApplyAdd.vue'
import companyApplyEdit from '@/views/organization/companyApplyEdit.vue'

export default {
  name: 'companyApply',
  components: {
    companyApplyAdd,
    companyApplyEdit
  },
  data() {
    return {
      total: 0,
      page: 1,
      size: 10,
      pageSize: 10,
      loading: false, // 表格等待
      btnList: [],
      companyIds: '',
      formCustom: {
        companyName: '',
        organizationCode: '',
        owner: '',
        industryType: '',
        countyCode: [],
        companyScale: '',
        approvalStatus: ''
      },
      companyApplyColumns: [
        {type: 'index', title: '序号', align: 'center'},
        {title: '企业名称', key: 'companyName', align: 'center'},
        {title: '统一社会信用代码', key: 'organizationCode', align: 'center'},
        {title: '行业类型', key: 'industryTypeName', align: 'center'},
        {title: '法人姓名', key: 'owner', align: 'center'},
        {title: '企业注册地', key: 'countyName', slot: 'countyName', align: 'center'},
        {title: '企业规模(人)', key: 'companyScaleName', align: 'center'},
        {title: '审批状态', key: 'approvalStatus', slot: 'approvalStatus', align: 'center'},
        {title: '操作', slot: 'action', align: 'center', fixed: 'right'}
      ],
      companyApplyTableData: [], // 表格数据
      row: {},
      areaData: [],
      countyCode: '',
      industryTypeList: [], // 行业类型
      companyScaleList: [], // 企业规模
      addDialogVisible: false,
      editDialogVisible: false
    }
  },
  mounted() {
    const list = JSON.parse(localStorage.getItem('routerList'))
    // eslint-disable-next-line new-cap
    this.btnList = new permissionList(list, this.$route.path).getList()
    this.init()
  },
  methods: {
    // 初始化
    init() {
      this.loading = true
      companyApplyPage({
        current: 1,
        size: 10
      }).then((res) => {
        this.changeData(res)
      })
      allDivisionTree().then((response) => {
        this.areaData = response.data.data
      })
      industryTypeList().then((response) => {
        this.industryTypeList = response.data.data
      })
      companyScaleList().then((response) => {
        this.companyScaleList = response.data.data
      })
    },
    selectionChange(rows) {
      if (rows && rows.length > 0) {
        let ids = []
        rows.forEach(row => {
          ids.push(row.companyId)
        })
        this.companyIds = ids.join(",")
      }
    },
    // 查询
    handleSearch() {
      const data = {
        ...this.formCustom
      };
      if (this.formCustom.countyCode.length > 0) {
        data.countyCode = this.countyCode
      }
      companyApplyPage({
        current: 1,
        size: this.pageSize,
        ...data
      }).then((res) => {
        this.changeData(res)
        this.$refs['pages'].currentPage = 1 // 分页变成第一页
      })
    },
    // 调接口获取表格数据
    changeData(res) {
      this.total = res.data.data.total
      this.size = res.data.data.size
      this.companyApplyTableData = res.data.data.records
      this.loading = false
    },
    // 重置
    handleReset(name) {
      this.$refs[name].resetFields()
      // 重置查询条件会再次查询
      this.handleSearch()
    },
    // 改变页码
    setCurrent(val) {
      const data = {
        ...this.formCustom
      };
      if (this.formCustom.countyCode.length > 0) {
        data.countyCode = this.countyCode
      }
      this.loading = true
      this.page = val
      companyApplyPage({
        current: val,
        size: this.pageSize,
        ...data
      }).then((res) => {
        this.changeData(res)
      })
    },
    // 改变每页条数
    setPage(val) {
      const data = {
        ...this.formCustom
      };
      if (this.formCustom.countyCode.length > 0) {
        data.countyCode = this.countyCode
      }
      this.loading = true
      this.pageSize = val
      companyApplyPage({
        current: 1,
        size: this.pageSize,
        ...data
      }).then((res) => {
        this.changeData(res)
        this.$refs['pages'].currentPage = 1 // 分页变成第一页
      })
    },
    changeCountyCode(v, d) {
      this.countyCode = d.slice(-1)[0].id
    },
    addDialogShow() {
      this.addDialogVisible = true
    },
    editDialogShow(row) {
      this.row = row
      this.editDialogVisible = true
    },
    addSuccess() {
      this.addDialogVisible = false
      this.handleSearch()
    },
    editSuccess() {
      this.editDialogVisible = false
      this.handleSearch()
    }
  }
}
</script>
